import { render } from "./TicketBooking.vue?vue&type=template&id=2b6f321b&scoped=true"
import script from "./TicketBooking.vue?vue&type=script&lang=js"
export * from "./TicketBooking.vue?vue&type=script&lang=js"

import "./TicketBooking.vue?vue&type=style&index=0&id=2b6f321b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6f321b"]])

export default __exports__